// extracted by mini-css-extract-plugin
export default {"mission":"misson_mission__Z-Oh9"};